// Remove o coração do último item visível do menu
document.addEventListener('DOMContentLoaded', function () {
  function fixLastHeart() {
    const lists = document.querySelectorAll('.header-menu .menu-list__list');
    lists.forEach(function (list) {
      const items = Array.from(list.querySelectorAll('.menu-list__list-item:not([aria-hidden="true"])')).filter(
        function (el) { return el.getAttribute('slot') !== 'overflow'; }
      );
      items.forEach(function (item) { item.classList.remove('gk-no-heart'); });
      if (items.length > 0) {
        items[items.length - 1].classList.add('gk-no-heart');
      }
    });
  }

  fixLastHeart();

  const observer = new MutationObserver(fixLastHeart);
  document.querySelectorAll('.header-menu .menu-list__list').forEach(function (list) {
    observer.observe(list, { childList: true, subtree: true, attributes: true, attributeFilter: ['aria-hidden'] });
  });
});
